import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

function StepConfirm({
  images,
  productData,
  prevStep,
  handleSubmitProduct,
  isAuthenticated,
  handleCancel, // Prop para resetear el wizard en el padre
}) {
  // Enlaces de invitado si no está autenticado
  const guestLinks = (
    <div className="flex items-center space-x-4">
      <Link
        to="/login"
        className="text-base font-medium text-black hover:text-gray-900"
      >
        Login
      </Link>
      <Link
        to="/signup"
        className="inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-emerald-600 hover:bg-emerald-700"
      >
        Sign up
      </Link>
    </div>
  );

  const onCancel = () => {
    // Si el usuario no está autenticado, reiniciamos el wizard
    if (!isAuthenticated && handleCancel) {
      handleCancel();
    }
    // Cerrar el modal
    document.getElementById("my_modal_5").close();
  };

  const handlePrev = () => prevStep();

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Step 4: Confirmation</h2>
      <p className="mb-4">Review the data before uploading your product:</p>

      <div className="flex flex-col md:flex-row gap-4">
        {/* Left panel: muestra las 4 capturas (3 fotos + 1 video) */}
        <div className="md:w-1/2 grid grid-cols-2 gap-2">
          {images.map((media, i) => (
            <div
              key={i}
              className="border rounded p-2 flex items-center justify-center"
            >
              {media ? (
                i === 3 ? (
                  <video
                    src={media}
                    controls
                    className="max-h-40 rounded border"
                  />
                ) : (
                  <img
                    src={media}
                    alt={`Media ${i + 1}`}
                    className="max-h-40 rounded border"
                  />
                )
              ) : (
                <span className="text-sm text-gray-500">Not captured</span>
              )}
            </div>
          ))}
        </div>

        {/* Right panel: muestra los datos del producto */}
        <div className="md:w-1/2 space-y-2">
          {productData.name && (
            <div>
              <span className="font-semibold">Name: </span>
              <span>{productData.name}</span>
            </div>
          )}
          {productData.description && (
            <div>
              <span className="font-semibold">Description: </span>
              <span>{productData.description}</span>
            </div>
          )}
          {productData.price && (
            <div>
              <span className="font-semibold">Price: </span>
              <span>{productData.price}</span>
            </div>
          )}
          {productData.compare_price && (
            <div>
              <span className="font-semibold">Compare Price: </span>
              <span>{productData.compare_price}</span>
            </div>
          )}
          {productData.type && (
            <div>
              <span className="font-semibold">Type: </span>
              <span>{productData.type}</span>
            </div>
          )}
          {productData.condition && (
            <div>
              <span className="font-semibold">Condition: </span>
              <span>{productData.condition}</span>
            </div>
          )}
          {productData.size && (
            <div>
              <span className="font-semibold">Size: </span>
              <span>{productData.size}</span>
            </div>
          )}
          {productData.color && (
            <div>
              <span className="font-semibold">Color: </span>
              <span>{productData.color}</span>
            </div>
          )}
          {productData.material && (
            <div>
              <span className="font-semibold">Material: </span>
              <span>{productData.material}</span>
            </div>
          )}
          {productData.brand && (
            <div>
              <span className="font-semibold">Brand: </span>
              <span>{productData.brand}</span>
            </div>
          )}
          {productData.quantity && (
            <div>
              <span className="font-semibold">Quantity: </span>
              <span>{productData.quantity}</span>
            </div>
          )}

          {!isAuthenticated && (
            <p className="mt-2">To upload your product you must register</p>
          )}
        </div>
      </div>

      {/* Botones finales */}
      <div className="mt-6 flex justify-between">
        <button
          onClick={onCancel}
          className="btn btn-outline text-xs sm:text-sm px-3 sm:px-4 w-auto max-w-[100px]"
        >
          Cancel
        </button>
        {!isAuthenticated ? (
          guestLinks
        ) : (
          <div className="flex items-center space-x-4">
            <button
              onClick={handlePrev}
              className="btn text-xs sm:text-sm px-3 sm:px-4 w-auto max-w-[100px]"
            >
              Previous
            </button>
            <button
              onClick={handleSubmitProduct}
              className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded w-auto "
            >
              Publish Product
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.Auth.isAuthenticated,
});

export default connect(mapStateToProps)(StepConfirm);
